import { render, staticRenderFns } from "./vistadecompras.vue?vue&type=template&id=0cb1721e&"
import script from "./vistadecompras.vue?vue&type=script&lang=js&"
export * from "./vistadecompras.vue?vue&type=script&lang=js&"
import style0 from "./vistadecompras.vue?vue&type=style&index=0&id=0cb1721e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports